module.exports = __webpack_public_path__ + "img/after.73cdaf6f.png";